import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { createValidator, required } from 'utils/formValidations';
import { getHasDynamicPricing } from 'utils/purchase/dynamicPricing';
import { setError } from '@/actions';
import { applyDiscount } from '@/actions/purchase';
import { hasCdsAccount, isCdsCouponBlocked } from 'utils/purchase/cdsPointsRecovery';
import DiscountCodeComponent from './DiscountCode';

const validate = createValidator({
  discountCode: [required],
});

const mapStateToProps = (state) => {
  const { purchase } = state;
  const departDiscountType = purchase.getIn(['departs', 'fragments', 0, 'pricing', 'discountType']);
  const returnDiscountType = purchase.getIn(['returns', 'fragments', 0, 'pricing', 'discountType']);

  return {
    token: purchase.get('token'),
    selectedInstallmentsPlan: purchase.get('selectedInstallmentsPlan').toObject(),
    applyingDiscount: purchase.get('applyingDiscount'),
    cdsCouponBlocked: isCdsCouponBlocked(
      {
        token: purchase.get('token'),
        cdsPointsEnabled: purchase.get('cdsPointsEnabled'),
        cdsPointsPreview: purchase.get('cdsPointsPreview'),
        cdsPointsRedemptionId: purchase.get('cdsPointsRedemptionId'),
        cdsPointsRedemption: purchase.get('cdsPointsRedemption')?.toJS(),
      },
      hasCdsAccount(state.whitelabelConfig.env),
    ),
    hasDynamicPricing: getHasDynamicPricing(departDiscountType, returnDiscountType),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onApplyDiscount: (token, code, selectedInstallmentsPlan) =>
    dispatch(applyDiscount(token, code, selectedInstallmentsPlan)),

  onDiscountCodeFail: () => dispatch(setError(null, 'write_a_discount_code', 'warning', false)),
});

const DiscountCodeForm = reduxForm({
  form: 'discountCode',
  validate,
})(DiscountCodeComponent);

export default connect(mapStateToProps, mapDispatchToProps)(DiscountCodeForm);
